import axios from "axios";
import { useEffect, useState } from "react";
import { HEADERS_API } from "../NuevaGuia";
import { ValidarLtr, ValidarNum, ValidarNumLtr } from "../../shared/Regex";
import { NMTipoDocumento } from "../../shared/Denominaciones";

export default function FormularioAsignarVehiculo({funcionCancelar, funcionAsignar}){
    //#region STATE
    // =========================================================================================
    
    const [listaVehiculos, setListaVehiculos] = useState([]);
    const [listaAsignar, setListaAsignar] = useState([]);
    // Estados de validación
    
    //#endregion

    //#region EFFECT
    // =========================================================================================
    useEffect(()=>{
        const asyncInicial = async () => {
            await ObtenerVehiculosAsignar();
        }

        asyncInicial();
    },[])
    //#endregion

    //#region  HANDLERS
    // =========================================================================================
    const HandlerListaVehiculos = (valor) => {
        setListaVehiculos(valor);
    }
    const HandlerListaAsignar = (valor) => {
        setListaAsignar(valor);
    }
    //#endregion

    //#region FUNCIONES
    // =========================================================================================

    const EjecutarFuncionAsignar = () => {
        funcionAsignar(listaAsignar);
        funcionCancelar();
    }

    const ItemLista = (sender, item) => {
        if(listaAsignar.find(vehiculo => vehiculo.placa == item.placa)){
            const listaActual = listaAsignar;
            const listaActualizada = listaActual.filter(vehiculo => vehiculo.placa != item.placa);
            HandlerListaAsignar(listaActualizada);
            sender.target.classList.remove('active');
        }else{
            if(listaAsignar.length < 3){
                HandlerListaAsignar([...listaAsignar, item]);
                sender.target.classList.add('active');
            }
        }
    }

    // FUNCIONES ASÍNCRONAS
    const ObtenerVehiculosAsignar = async () => {
        try{    
            const response = await axios.get(URL_ASIGNAR_VEHICULOS,{
                headers: HEADERS_API
            }).catch(error => {
                if(error.response){
                    throw new Error(error.response.data.title);
                }else{
                    throw new Error(error.message);
                }
            });

            if(response.mensajeError != null){
                throw new Error(response.mensajeError);
            }
            HandlerListaVehiculos(response.data.lista);
        }catch(error){
            console.log(error.message);
        }
    }
    
    //#endregion

    //#region CONTENIDO
    // =========================================================================================
    return (
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                ASIGNAR VEHÍCULOS
            </div>
            <div className=" p-2">
                <div className="row">
                    <div className="col-12 p-2">
                        <div className="list-group">
                            {
                                listaVehiculos.map((item, index) => 
                                <div onClick={(e)=>ItemLista(e, item)} key={index} className="list-group-item list-group-item-action">
                                    {item.descripcion} - {item.placa}
                                </div>)
                            }
                        </div>
                    </div>
                    <div className="col-12 py-4">
                        {
                            listaAsignar.map((item, index) =>
                                <div key={index} className="px-2">
                                    <span className="fw-bold">{index == 0 ? "Principal: " : "Secundario: "}</span>
                                    <span>{item.descripcion} - {item.placa}</span>
                                </div>
                            )
                        }
                    </div>
                    <div className="p-2 d-flex justify-content-around">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                        <button onClick={EjecutarFuncionAsignar} disabled={listaAsignar.length < 1} className="btn btn-primary">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
    //#endregion
}

//#region CONSTANTES
const URL_ASIGNAR_VEHICULOS = process.env.REACT_APP_URL_ASIGNAR_VEHICULOS;
//#endregion